/**
 * @module
 * @category Component
 */

'use client';

import { ChipSkeleton } from 'BomdisoftComponents/skeletons/chip';
import { ReactNode, Suspense } from 'react';

type SuspenseWrapperProps = {
  children: ReactNode;
  fallback?: ReactNode;
};

export const SuspenseWrapper = ({ children, fallback }: SuspenseWrapperProps) => <Suspense fallback={fallback ?? <ChipSkeleton />}>{children}</Suspense>;

type SuspenseChipProps = {
  children: ReactNode;
  width?: number;
};

export const SuspenseChip = ({ children, width = 100 }: SuspenseChipProps) => <Suspense fallback={<ChipSkeleton width={width} />}>{children}</Suspense>;
